import { render } from "./GamificationAccomplishmentsAchivements.vue?vue&type=template&id=c1e2f68c"
import script from "./GamificationAccomplishmentsAchivements.vue?vue&type=script&lang=js"
export * from "./GamificationAccomplishmentsAchivements.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__